import { POST_PURCHASE_NEXT_STEPS_TYPES } from "@/domains/surveys/models/constants";
import { MOCK_CATALOG, type MockCatalogProduct } from "@/mocks/data/catalog";
import type { PostPurchaseRecommendationsWire, SurveyParamsWire } from "@/mocks/types";

const productParams = (product: MockCatalogProduct): SurveyParamsWire => {
  return [
    [`${product.sku}ProductName`, product.name],
    [`${product.sku}ProductImgUrl`, product.images[0]],
  ];
};

export const MOCK_POST_PURCHASE_PARAMS: SurveyParamsWire = [
  ["FirstName", "Casey"],
  ["Symptoms", "Stress and Sleep"],
  ...productParams(MOCK_CATALOG.RAPID_RELIEF),
  ...productParams(MOCK_CATALOG.CALM_DAY),
];

const upsellProduct = (product: MockCatalogProduct, shopifyOrigin: string, description: string) => {
  return {
    name: product.name,
    description,
    imgUrl: product.images[0],
    url: `${shopifyOrigin}/products/${product.handle}`,
    price: product.priceInCents,
    variantId: product.variantId,
  };
};

export const createPostPurchaseRecommendations = (
  shopifyOrigin: string,
): PostPurchaseRecommendationsWire => {
  return {
    buyer: { firstName: "Casey", lastName: "Guest", email: "post-purchase@eo-design.test" },
    steps: [
      {
        header: "Keep your inhaler within reach",
        description:
          "Sample guidance: most people get the best results by using it at the first sign of discomfort instead of waiting.",
        type: POST_PURCHASE_NEXT_STEPS_TYPES.ADVICE,
      },
      {
        header: "Wait 15 minutes between puffs",
        description:
          "Sample guidance: the effect builds over a few minutes, so give each puff time to work before taking another.",
        type: POST_PURCHASE_NEXT_STEPS_TYPES.ALERT,
      },
    ],
    products: [
      upsellProduct(
        MOCK_CATALOG.CALM_DAY,
        shopifyOrigin,
        "A gentle daytime gummy for steady calm without feeling foggy.",
      ),
      upsellProduct(
        MOCK_CATALOG.NIGHT_REST,
        shopifyOrigin,
        "A slow-release gummy that helps you wind down and stay asleep.",
      ),
    ],
  };
};
